import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Dropdown,
    Form,
    Segment,
    SegmentContent,
    SegmentHeader,
} from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';

const subjectKey = subject => `${subject.type}:${subject.id}`;

const CommunicationStoreForm = () => {
    const { employee, communicable_subjects: subjects } = usePage().props;
    const { data, setData, post, errors, processing, reset } = useForm({
        subject_type: '',
        subject_id: '',
    });
    const { confirm, setLoading } = useConfirmationStore();

    if (!subjects?.length) {
        return null;
    }

    const handleChange = value => {
        const subject = subjects.find(subject => subjectKey(subject) === value);

        setData({
            subject_type: subject?.type ?? '',
            subject_id: subject?.id ?? '',
        });
    };

    const handleSubmit = () =>
        confirm({
            title: 'Communicatie aanmaken?',
            description:
                'Weet je zeker dat je communicatie wilt aanmaken? De communicatiemomenten worden automatisch ingepland.',
            confirmLabel: 'Aanmaken',
            variant: 'primary',
            onConfirm: close => {
                setLoading(true);

                post(
                    `/customers/${employee.customer_id}/employees/${employee.id}/communications`,
                    {
                        reset: [
                            'employee',
                            'communicable_subjects',
                            'navigation',
                        ],
                        preserveScroll: true,
                        onSuccess: () => reset(),
                        onFinish: close,
                    }
                );
            },
        });

    return (
        <Segment>
            <SegmentHeader header='Communicatie aanmaken' />
            <SegmentContent>
                <Form onSubmit={handleSubmit}>
                    <Dropdown
                        label='Voor'
                        value={
                            data.subject_type
                                ? subjectKey({
                                      type: data.subject_type,
                                      id: data.subject_id,
                                  })
                                : ''
                        }
                        required
                        options={subjects.map(subject => ({
                            id: subjectKey(subject),
                            name: subject.name,
                        }))}
                        onChange={handleChange}
                        error={errors?.subject_type || errors?.subject_id}
                    />
                    <div className='mt-4 flex items-center justify-end'>
                        <Button
                            variant='primary'
                            type='submit'
                            loading={processing}
                        >
                            Aanmaken
                        </Button>
                    </div>
                </Form>
            </SegmentContent>
        </Segment>
    );
};

export default CommunicationStoreForm;
